// extracted by mini-css-extract-plugin
export default {"anchor":"IBoTFVoe9Zh4sMkaWS7cHw=="};